/**
 * The livery picker (M6 plan P33, spec §7.1): presets and three colour fields (primary, secondary, accent) that feed
 * the `player_corp` hull-material uniforms (D-397). Thin; the presets are corpScreen.json `liveryPresets`.
 */
import type { ReactNode } from 'react'
import type { LiveryColors } from '../../strategic/types'
import { FocusButton } from '../focus'
import { liveryPresets } from './corpModel'

export interface LiveryPickerProps {
  livery: LiveryColors
  busy: boolean
  onChange(livery: LiveryColors): void
  /** First focus index in the `corp` group. */
  first: number
}

const FIELDS: readonly { key: keyof LiveryColors; label: string }[] = [
  { key: 'primary', label: 'Primary' },
  { key: 'secondary', label: 'Secondary' },
  { key: 'accent', label: 'Accent' },
]

/** How many focus indices the picker uses. */
export function liveryPickerSize(): number {
  return liveryPresets().length
}

export function LiveryPicker(p: LiveryPickerProps): ReactNode {
  let i = p.first
  return (
    <div className="corp-livery" data-testid="corp-livery">
      <div className="corp-livery__presets">
        {liveryPresets().map((preset, k) => (
          <FocusButton
            key={preset.label}
            group="corp"
            index={i++}
            className="ui-btn--small"
            testId={`corp-livery-preset-${k}`}
            disabled={p.busy}
            onActivate={() =>
              p.onChange({
                primary: preset.primary,
                secondary: preset.secondary,
                accent: preset.accent,
              })
            }
          >
            <span className="corp-swatch" style={{ background: preset.primary }} />
            <span className="corp-swatch" style={{ background: preset.secondary }} />
            <span className="corp-swatch" style={{ background: preset.accent }} />
            {preset.label}
          </FocusButton>
        ))}
      </div>
      <div className="corp-livery__fields">
        {FIELDS.map((f) => (
          <label key={f.key} className="corp-field">
            {f.label}
            <input
              type="color"
              value={p.livery[f.key]}
              disabled={p.busy}
              data-testid={`corp-livery-${f.key}`}
              onChange={(e) => p.onChange({ ...p.livery, [f.key]: e.target.value })}
            />
          </label>
        ))}
      </div>
    </div>
  )
}
